<template>
    <div class="mt-4">
    <v-row>
        <v-col cols="12" md="">
            <component :is="valueItems.length > 0 ? vAutocomplete : vTextField"
                :type="valueItems.length > 0 ? 'text' : 'number'" step="0.01" class="error lighten-5" hide-details
                :value="value.content.severities.criticalLow" outlined dense
                @change="val => saveSeverity('criticalLow', val)" :items="valueItems" item-value="threshold"
                item-text="name" clearable>
                <template slot="label">
                    Kritiek
                    <v-icon small>mdi-arrow-down</v-icon>
                </template>
            </component>
        </v-col>
        <v-col cols="12" md="">
            <component :is="valueItems.length > 0 ? vAutocomplete : vTextField"
                :type="valueItems.length > 0 ? 'text' : 'number'" step="0.01" class="warning lighten-5" hide-details
                :value="value.content.severities.warningLow" outlined dense @change="val => saveSeverity('warningLow', val)"
                :items="valueItems" item-value="threshold" item-text="name" clearable>
                <template slot="label">
                    Waarschuwing
                    <v-icon small>mdi-arrow-down</v-icon>
                </template>
            </component>
        </v-col>
        <v-col cols="12" md="">
            <component :is="valueItems.length > 0 ? vAutocomplete : vTextField"
                :type="valueItems.length > 0 ? 'text' : 'number'" step="0.01" class="info lighten-5" hide-details
                :value="value.content.severities.infoLow" outlined dense @change="val => saveSeverity('infoLow', val)"
                :items="valueItems" item-value="threshold" item-text="name" clearable>
                <template slot="label">
                    Informatief
                    <v-icon small>mdi-arrow-down</v-icon>
                </template>
            </component>
        </v-col>
        <v-col cols="12" md="">
            <component :is="valueItems.length > 0 ? vAutocomplete : vTextField"
                :type="valueItems.length > 0 ? 'text' : 'number'" step="0.01" class="success lighten-5" hide-details
                :value="value.content.severities.ok" outlined dense @change="val => saveSeverity('ok', val)"
                :items="valueItems" item-value="threshold" item-text="name" clearable>
                <template slot="label">
                    Oké
                </template>
            </component>
        </v-col>
        <v-col cols="12" md="">
            <component :is="valueItems.length > 0 ? vAutocomplete : vTextField"
                :type="valueItems.length > 0 ? 'text' : 'number'" step="0.01" class="info lighten-5" hide-details
                :value="value.content.severities.infoHigh" outlined dense @change="val => saveSeverity('infoHigh', val)"
                :items="valueItems" item-value="threshold" item-text="name" clearable>
                <template slot="label">
                    Informatief
                    <v-icon small>mdi-arrow-up</v-icon>
                </template>
            </component>
        </v-col>
        <v-col cols="12" md="">
            <component :is="valueItems.length > 0 ? vAutocomplete : vTextField"
                :type="valueItems.length > 0 ? 'text' : 'number'" step="0.01" class="warning lighten-5" hide-details
                :value="value.content.severities.warningHigh" outlined dense
                @change="val => saveSeverity('warningHigh', val)" :items="valueItems" item-value="threshold"
                item-text="name" clearable>
                <template slot="label">
                    Waarschuwing
                    <v-icon small>mdi-arrow-up</v-icon>
                </template>
            </component>
        </v-col>
        <v-col cols="12" md="">
            <component :is="valueItems.length > 0 ? vAutocomplete : vTextField"
                :type="valueItems.length > 0 ? 'text' : 'number'" step="0.01" class="error lighten-5" hide-details
                :value="value.content.severities.criticalHigh" outlined dense
                @change="val => saveSeverity('criticalHigh', val)" :items="valueItems" item-value="threshold"
                item-text="name" clearable>
                <template slot="label">
                    Kritiek
                    <v-icon small>mdi-arrow-up</v-icon>
                </template>
            </component>
        </v-col>
    </v-row>
    <div class="mt-6 d-flex">
                    <div class="ml-auto">
                        <div class="d-flex align-center w-100">
                        <div class="px-4 py-1 grey lighten-3" style="border-radius:4px 0px 0px 4px">{{ (value.measurementTypes && value.measurementTypes[0] && value.measurementTypes[0].unit) ? value.measurementTypes[0].unit.name : '' }}/</div>
                        <eod-autocomplete label="Tijdsvenster*" :info="'Alarm als de waarde met meer dan ... '+((value.measurementTypes && value.measurementTypes[0] && value.measurementTypes[0].unit) ? value.measurementTypes[0].unit.name : '')+' verandert binnen gekozen tijdsvenster'" :value="value.content.timewindow" @input="val => updateContent('timewindow', val)" hide-details :rules="[val => $validator.required(val, 'Tijdsvenster')]"  :items="timewindows"></eod-autocomplete>
                        </div>
                    </div>
                </div>
    </div>
</template>
<script>
import { VTextField, VAutocomplete } from 'vuetify/lib'

export default {
    name: 'eod-alarm-detail-thresholds',
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        valueItems: {
            type: Array,
            default: () => ([])
        },
    },
    data() {
        return {
            vTextField: VTextField,
            vAutocomplete: VAutocomplete,
            timewindows: [{value:60000, text:'1 min'}, {value:300000, text:'5 min'}, {value:900000, text:'15 min'}, {value:3600000, text:'1 uur'}, {value:86400000, text:'24 uur'}]

        }
    },
    created() {
        let val = this.value;
        if (!val.content.severities) {
            val.content.severities = {
                criticalLow: null,
                warningLow: null,
                infoLow: null,
                ok: null,
                infoHigh: null,
                warningHigh: null,
                criticalHigh: null,
            };
            this.$emit('input', val);
        }


    },
    methods: {
        updateContent(propName, value){
            const val = this.value;
            if (val) {
                val.content[propName] = value;
                this.$emit('input', val);
            }
        },
        saveSeverity(severityName, value) {
            const val = this.value;
            if (val) {
                val.content.severities[severityName] = value;
                this.$emit('input', val);
            }
        },
    }
}
</script>